module.exports = __webpack_public_path__ + "static/WEDDING E&M-47-add3e3d1449b963522137de213c41f0b.jpg";